import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { IDocument } from 'app/shared/models/recruitment/document.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject } from 'rxjs';
import { RecruitmentService } from '../../recruitment/recruitment.service';
import { saveAs } from 'file-saver';
import { IdentityService, IDtoEmployeeModuleProfile } from '../../security/identity.service';
import { BsModalService } from 'ngx-bootstrap';
import { ModalSalaryFormatComponet } from 'app/views/modales/employees/salary-format/modal-salary-format.component';

@Component({
  selector: '[app-employee-documents]',
  templateUrl: './employee-documents.template.html',
  styleUrls: ['./employee-documents.style.scss']
})
export class EmployeeDocumentsComponent implements OnInit {
  private catalogDocuments: Observable<IDocument[]>;
  private formDocuments: FormGroup;
  private activateSave: IDtoEmployeeModuleProfile;
  @Input() private employeeId: number;
  @Input() documents: Subject<IDocument[]> = new Subject<IDocument[]>();
  @Input() private profile: string;
  @Input() private email: string;
  public constructor(private recruitmentService: RecruitmentService
    , private identityService: IdentityService
    , private formBuilder: FormBuilder
    , private spinner: NgxSpinnerService
    , private configGeneral: AppConfig
    , private modalService: BsModalService) { }

  ngOnInit() {
    this.documents.subscribe(res => {
      if (res) {
        if (res.length > 0) {
          this.catalogDocuments.subscribe((docs) => {
            docs.forEach(element => {
              element.fileName = null;
              element.path = null;
              element.id = null;
              const d = res.filter(x => x.documentName === element.documentName)[0];
              if (d !== undefined) {
                element.fileName = d.fileName;
                element.path = d.path;
                element.id = d.id;
              }
            });
          })
        } else {
          this.catalogDocuments.subscribe((docs) => {
            docs.forEach(element => {
              element.fileName = null;
              element.path = null;
              element.id = null;
            });
          })
        }
      }
    })
    this.catalogDocuments = this.recruitmentService.getCatalogDocumens();
    this.activateSave = this.identityService.activateSaveForm(this.profile);
    this.initializeFormDocuments();
  }
  private initializeFormDocuments() {
    this.formDocuments = this.formBuilder.group({
      tableDocuments: [null]
    });
  }
  private readFormControlEmployeeModule(control: string): boolean {
    return this.identityService.readFormControlEmployeeModule(this.profile, control);
  }
  private onFileChange(event) {
    event.value = '';
  }
  private handleFileInput(item: IDocument, files: FileList) {
    const file = files.item(0);
    let ext = file.name.split('.').pop().toLowerCase();
    if (this.validateExt(ext, item.type)) {
      this.upload(item, file);
    } else {
      this.configGeneral.newToast('Validación', `Asegúrese de seleccionar el tipo de archivo correcto (${item.type})`, 'error');
    }
  }
  private validateExt(ext: string, listExts: string): boolean {
    const list = listExts.split(',').map(x => x.trim().toLowerCase());
    const e = list.filter(x => x === `.${ext}`)[0];
    if (e == undefined) {
      return false
    } else {
      return true;
    }
  }
  private upload(item: IDocument, file: File): void {
    this.spinner.show();
    if (this.employeeId === undefined || this.employeeId === 0) {
      this.spinner.hide();
      this.configGeneral.newToast('Validación', 'Capture y guarde información general primeramente', 'warning');
      return;
    }
    if (file.size > 2097152) {
      this.spinner.hide();
      this.configGeneral.newToast('Validación', 'No es posible subir documentos con un peso mayor a 2MB', 'warning');
      return;
    }
    item.fileName = file.name;
    item.jobCandidateId = this.employeeId;
    item.id = 0;
    this.recruitmentService.uploadFile(item, file).subscribe((res) => {
      if (res.isCorrect === true) {
        const doc = res.data as IDocument;
        item.fileName = doc.fileName;
        item.path = doc.path;
        item.id = doc.id;
        this.spinner.hide();
        this.configGeneral.newToast('Éxito', 'Documento cargado correctamente', 'success');
      } else {
        this.configGeneral.newToast('Error', res.message, 'error');
        this.spinner.hide();
      }
    },
    (errMessage) => {
        this.spinner.hide();
        this.configGeneral.newToast('Error', errMessage.error.message, 'error');
    });
  }
  private deleteFile(item: IDocument): void {
    if (item.id == undefined) {
      return;
    }
    this.recruitmentService.deleteFile(item.id).subscribe((res) => {
      if (res.isCorrect === true) {
        item.fileName = undefined;
        item.path = undefined;
        item.id = undefined;
        this.configGeneral.newToast('Éxito', 'Documento eliminado correctamente', 'success');
      }
    });
  }
  private downloadFile(item: IDocument): void {
    if (item.id == undefined) {
      return;
    }
    this.recruitmentService.downloadFile(item.id).subscribe((res) => {
      if (res.isCorrect === true) {
        const file = res.data as any;
        const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
        saveAs(blob, file.fileDownloadName);
      } else {
        this.configGeneral.newToast('Error', res.message, 'error');
      }
    });
  }
  private openModalSalaryFormat() {
    const initialState = {
        employeeId: this.employeeId
        , email: this.email
    };
    this.modalService.show(ModalSalaryFormatComponet
        , Object.assign({ initialState }
            , { class: 'modal-lg' }
            , this.configGeneral.configModal));
}
}
